import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { ExclamationMarkIcon } from '@repo/ui/icons'
import Typography from '@repo/ui/typography'
import { Fragment } from 'react/jsx-runtime'

import useTranslate from '../../../lib/hooks/use-translate'
import { staffMissingDocumentTypeEnumMapping } from '../../../lib/types/enums/common/document-status.enum'
import {
  StaffMissingDocument,
  StaffMissingInformationItem
} from '../../../lib/types/models/staff/staff'

type Props = {
  data: StaffMissingDocument[]
  onMissingDocumentClick: (document: StaffMissingDocument) => void
  additionalMissingInformation?: StaffMissingInformationItem[]
}

const StaffMissingDocumentsContainer = ({
  data,
  onMissingDocumentClick,
  additionalMissingInformation = []
}: Props) => {
  const { t } = useTranslate()
  const missingItems = [
    ...data.map((document) => ({
      label: staffMissingDocumentTypeEnumMapping(document).label,
      onClick: () => {
        onMissingDocumentClick(document)
      }
    })),
    ...additionalMissingInformation
  ]

  return (
    <div className="bg-red-light rounded-lg w-full p-3 flex gap-1 items-center">
      <div>
        <ExclamationMarkIcon filled={false} color={tailwindColors.red.DEFAULT} />
      </div>
      <div className="flex flex-wrap gap-1">
        <Typography
          variant="label-medium"
          color={tailwindColors.red.DEFAULT}
          className="whitespace-nowrap"
        >
          {t('staff.personal.space.missing.documents')}
        </Typography>
        {missingItems.map((item, index) => (
          <Fragment key={`${item.label}-${index}`}>
            <Typography
              variant="label-semibold"
              color={tailwindColors.red.DEFAULT}
              className="underline cursor-pointer whitespace-nowrap"
              onClick={item.onClick}
            >
              {t(item.label)}
            </Typography>
            {index !== missingItems.length - 1 && (
              <Typography variant="label-medium" color={tailwindColors.red.DEFAULT}>
                ,
              </Typography>
            )}
          </Fragment>
        ))}
      </div>
    </div>
  )
}

export default StaffMissingDocumentsContainer
